__turbopack_context__.v({
  "map": "style-module-scss-module__6wPKCW__map",
  "price-history-placeholder": "style-module-scss-module__6wPKCW__price-history-placeholder",
  "smdc-tabs": "style-module-scss-module__6wPKCW__smdc-tabs",
});
